const LastPlacementTestSetter = (record) => {
    const last_placement_test_value =
      record.placement_tests[record.placement_tests.length - 1];
    return last_placement_test_value;
  };
export default LastPlacementTestSetter;